const STEPS = [3600, 60, 1];

export class TimeCode {
    hours: number = 0;
    minutes: number = 0;
    seconds: number = 0;
    frames: number = 0;
    fps: number = 25;

    constructor(hours: number, minutes: number, seconds: number, frames: number, fps: number) {
        this.hours = hours;
        this.minutes = minutes;
        this.seconds = seconds;
        this.frames = frames;
        this.fps = fps;
    }

    public static parseString(timeCode: string, fps: number = 25): TimeCode {
        const [hours, minutes, seconds, frames] = timeCode
            .split(":")
            .map((value) => parseInt(value));

        return new TimeCode(hours, minutes, seconds, frames, fps);
    }

    public static parseNumber(timeCode: number | string, fps: number = 25, inMillis: boolean = false): TimeCode {
        if (typeof timeCode === "string") timeCode = parseFloat(timeCode);

        if (inMillis) timeCode /= 1000;
        const frames = TimeCode.MsToFrames(timeCode % 1 * 1000);
        let rest = Math.floor(timeCode);

        const [hours, minutes, seconds] = STEPS.map((step) => {
            const value = Math.floor(rest / step);
            rest = rest - (value * step);
            return value;
        });

        return new TimeCode(hours, minutes, seconds, frames, fps);
    }

    static MsToFrames(ms: number, fps: number = 25): number {
        return Math.round(ms / 1000 * fps);
    }

    static FramesToMs(frames: number, fps: number = 25): number {
        return Math.round(frames / fps * 1000);
    }

    static add(first: TimeCode, second: TimeCode): TimeCode {
        return TimeCode.parseNumber(first.toSeconds() + second.toSeconds(), first.fps);
    }

    public toString(millis: boolean = false): string {
        let timeCode = [
            this.hours.toString().padStart(2, "0"),
            this.minutes.toString().padStart(2, "0"),
            this.seconds.toString().padStart(2, "0")
        ].join(":");

        if (millis) {
            timeCode += "." + TimeCode.FramesToMs(this.frames).toFixed(0).padStart(3, "0");
        } else {
            timeCode += ":" + this.frames.toString().padStart(2, "0");
        }

        return timeCode;
    }

    public toMilliseconds(): number {
        return this.toSeconds() * 1000;
    }

    public toSeconds(): number {
        let seconds = 0;
        const iter = [this.hours, this.minutes, this.seconds];
        STEPS.forEach((step: number, index: number) => seconds += iter[index] * step);
        seconds += TimeCode.FramesToMs(this.frames) / 1000;
        return seconds;
    }
}
